import { Suspense, lazy } from "react";
import { Workspace } from "./layout/Workspace";

/**
 * Enrutado mínimo, sin dependencia de router: la aplicación tiene dos vistas
 * —el espacio de trabajo y el banco de pruebas de bloques— y una comprobación
 * de ruta basta. Vite sirve `index.html` para cualquier ruta en desarrollo.
 *
 * El banco de pruebas se carga en diferido: es una herramienta de desarrollo y
 * no tiene por qué viajar en el bundle que descarga el estudiante.
 */
const BlocksPreview = lazy(() =>
  import("./dev/BlocksPreview").then((module) => ({ default: module.BlocksPreview })),
);

export function App() {
  const path = typeof window === "undefined" ? "/" : window.location.pathname;
  if (path.startsWith("/dev/blocks")) {
    return (
      <Suspense fallback={<div className="app-loading">Cargando banco de pruebas…</div>}>
        <BlocksPreview />
      </Suspense>
    );
  }
  return <Workspace />;
}

export default App;
